<template>
  <div>
    <div class="wrapper">
      <b-row class="mt-2 mb-2">
        <b-col>
          <b-button class="pull-right" variant="primary" v-b-modal.create-portal-user>Gebruiker aanmaken</b-button>
        </b-col>
      </b-row>
      <div class="animated fadeIn">
        <resource-index header="Portal gebruikers" endpoint="portal-users" show-route="portal-users.view"/>
      </div>
    </div>
    <b-modal id="create-portal-user" title="Portal gebruiker aanmaken" hide-footer>
      <b-form @submit.prevent="createUser">
        <b-form-group label="Gebruikersnaam">
          <b-form-input type="text" @keyup="removeSpaces" required v-model="item.username"></b-form-input>
        </b-form-group>
        <b-form-group label="Kies type">
          <b-form-select name="account_type" v-model="item.type" :options="accountOptions" required></b-form-select>
        </b-form-group>
        <b-form-group label="Kies Salesforce Relatie" v-if="item.type === 'account'">
          <b-form-select name="account_type" v-model="item.accountId" :options="accounts" required></b-form-select>
        </b-form-group>
        <b-form-group label="Kies Salesforce Contactpersoon" v-if="item.type === 'contact'">
          <b-form-select name="account_type" v-model="item.contactId" :options="contacts" required></b-form-select>
        </b-form-group>
        <b-form-group label="Stuur gebruiker uitnodiging">
          <b-form-checkbox switch name="invitation" v-model="item.invitation" value=1
                           unchecked-value=0></b-form-checkbox>
        </b-form-group>
        <hr>
        <b-button class="pull-left" variant="danger" @click="closeModal">Annuleer</b-button>
        <b-button type="submit" class="pull-right" variant="success">Maak gebruiker aan</b-button>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import ResourceIndex from '../../components/ResourceIndex';
import {addData, getData} from "@/api";

export default {
  name: 'users',
  components: {ResourceIndex},
  data() {
    return {
      item: {
        username: null,
        type: null,
        accountId: null,
        contactId: null,
        invitation: 0,
      },
      contacts: [],
      accounts: [],
      accountOptions: [
        {value: null, text: 'Kies een type...'},
        {value: 'account', text: 'Salesforce Relatie'},
        {value: 'contact', text: 'Salesforce Contactpersoon'},
      ]
    }
  },
  methods: {
    async getContacts() {
      this.contacts = await getData('accounts/contacts/select').then(response => response.data);
    },
    async getAccounts() {
      this.accounts = await getData('accounts/select').then(response => response.data);
    },
    async createUser() {
      let request = await addData('portal-users', {
        username: this.item.username,
        type: this.item.type,
        account_id: this.item.accountId,
        contact_id: this.item.contactId,
        invitation: this.item.invitation
      }).then(response => response);

      if (request.status === 201) {
        return this.$router.push({name: 'portal-users.view', params: {id: request.data.data.id}});
      }
    },
    async closeModal() {
      this.$bvModal.hide('create-portal-user');
      this.item = {
        username: null,
        type: null,
        accountId: null,
        contactId: null,
        invitation: 0,
      };
    },
    removeSpaces() {
      this.item.username = this.item.username.split(' ').join('');
    }
  },
  beforeMount() {
    this.getContacts();
    this.getAccounts();
  },

}

</script>
